module.exports = __webpack_public_path__ + "static/apple-touch-icon-835f67a0a60a70f9b82c9817d24202b3.png";